import OfferIntro from './OfferIntro';

export default OfferIntro;
